module.exports = {
    title: "Thriving Mind Request",
    industry: "Industry",
    groups: "Groups",
    description: "Description",
    referenceLink: "Reference Link",
    blockReason: "Block Reason",
    rejectionReason: "Rejection Reason",
    user: {
        name: 'Name'
    },
    validation: {
        required: {
            title: 'Title is required',
        }
    },
}
